/*
* <license header>
*/

import React from 'react'
import PropTypes from 'prop-types'
import { Routes, Route } from 'react-router-dom'
import WebsiteLayout from './website/WebsiteLayout'
import VotePage from './website/VotePage'
import SummaryPage from './website/SummaryPage'
import './website/website-voting.css'

export function Website ({ ims }) {
  return (
    <div className="website-voting-root">
      <Routes>
        <Route element={<WebsiteLayout ims={ims} />}>
          <Route index element={<VotePage />} />
          <Route path="summary" element={<SummaryPage />} />
        </Route>
      </Routes>
    </div>
  )
}

Website.propTypes = {
  ims: PropTypes.object
}
